import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, NavLink } from 'react-router-dom';
import axios from '../../../_services/api/axios';
import withErrorHandler from '../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../_store/actions/index';
import Aux from '../../../_hoc/_Aux';
import { getTranslate } from 'react-localize-redux';
import ReactTooltip from 'react-tooltip'
import * as FormHelpers from '../../../_helpers/Form.js';

import { PageTemplate, Header, FlexColumn, PageTitle, Form, GreyBox, Wizard, Flex, Toggle, InputRow, Input, Select, Button, UploadButton, Spacer, Text, Box } from 'components'

class JobsNewPage extends Component {
	defaultFormState = {
        name : {
            state : false,
            message : false
        },
        orders : {
            state : false,
            message : false
        },
        pieces : {
            state : false,
            message : false
        },
        stitches : {
            state : false,
            message : false
        },
        colors : {
            state : false,
            message : false
        },
        color_changes : {
            state : false,
            message : false
        },
        trims : {
            state : false,
            message : false
        },
        cone_changes : {
            state : false,
            message : false
        },
        garment_handling : {
            state : false,
            message : false
        },
        hooping : {
            state : false,
            message : false
        },
        other_work : {
            state : false,
            message : false
        }
    }
    defaultMessageState = {
        show : false,
        message : null
    }
    constructor(props) {
        super(props);
        this.state = {
	        form : {
	        	name: "",
				orders: 0,
				pieces: 0,
				stitches: 0,
				colors: 0,
				color_changes: 0,
				trims: 0,
				cone_changes: 0,
				garment_handling: 0,
				hooping: 0,
				other_work: 0
	        },
	        form_state: this.defaultFormState,
	        message : this.defaultMessageState,
            form_blocked: false,
            willSubmit: false,
            wizard : {
                steps : [{
                    name : this.props.translate('jobnewpage.step_1.name'),
                    active : true
                },{
                    name : this.props.translate('jobnewpage.step_2.name'),
                    active : false
                },{
                    name : this.props.translate('jobnewpage.step_3.name'),
                    active : false
                }]
            }
		}
	}

    componentDidMount = () => {
        this.props.onFetchJobsDefaults();
    }

    componentWillUnmount = () => {
    	this.props.onResetJob();
        this.props.onCalculatorJobDuplicateCheckReset();
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
    	if(prevProps.calculatorJobsDefaults !== this.props.calculatorJobsDefaults) {
	        this.defaultValueHandler();  		
	    }
        if(prevProps.defaults !== this.props.defaults) {
            this.setState(prevState => ({
                wizard : {
                    ...prevState.wizard,
                    steps : [{
                        name : this.props.translate('jobnewpage.step_1.name'),
                        active : true
                    },{
                        name : this.props.translate('jobnewpage.step_2.name'),
                        active : false
                    },{
                        name : this.props.translate('jobnewpage.step_3.name'),
                        active : false
                    }]
                }
            }))            
        }
        //Duplicate Check
        if(!prevProps.state.job.name_checked && this.props.state.job.name_checked) {
            this.setState(prevState => ({
                form_blocked: !this.props.state.job.name_available ? true : false,
                form_state : {
                    ...prevState.form_state,
                    name : {
                        ...prevState.form_state.name,
                        state : this.props.state.job.name_available ? 'success' : 'error',
                        message : !this.props.state.job.name_available ? this.props.translate('jobnewpage.error.name_exists') : null
                    }
                }
            }));
            if(this.state.willSubmit) {
                this.setState(prevState => ({
                    willSubmit : false
                }), () => {
                    if(this.props.state.job.name_available) {
                        this.submitHandler();
                    }
                });
            }
        }
        // Errors
	    if(prevProps.state.job.error !== this.props.state.job.error) {
            if(this.props.state.job.error.length) {
                this.setState(prevState => ({
                    form_state: this.defaultFormState
                }), () => {
                    this.props.state.job.error.forEach((error, index) => {
                        if(this.state.form_state[error.source]) {
                            this.setState(prevState => ({
                                form_state : {
                                    ...prevState.form_state,
                                    [error.source] : {
                                        state : 'error',
                                        message : this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg: error.message})
                                    }
                                }
                            }))
                        }
                    })
                });
            }
            if(this.props.state.job.error.length === 1) {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('jobnewpage.error.'+this.props.state.job.error[0].key.toLowerCase(),null,{missingTranslationMsg: this.props.translate('jobnewpage.error.default')}),
                        type: "error"
                    }
                }));

            }
            else {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('jobnewpage.error.default'),
                        type: "error"
                    }
                }));
            }
        }
        else if (prevProps.helpersDesign.error !== this.props.helpersDesign.error && this.props.helpersDesign.error) {
            if(this.props.helpersDesign.error.length === 1) {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('jobnewpage.error.'+this.props.helpersDesign.error[0].key.toLowerCase(),null,{missingTranslationMsg: this.props.translate('jobnewpage.error.designupload')}),
                        type: "error"
                    }
                }));

            }
            else {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('jobnewpage.error.designupload'),
                        type: "error"
                    }
                }));
            }
        }
        //Design upload
        if(prevProps.helpersDesign.details !== this.props.helpersDesign.details && Object.keys(this.props.helpersDesign.details).length) {
            let steps = [...this.state.wizard.steps];
            steps[2].active = false;
            steps[1].active = true;
            steps[0].active = false;
            this.setState(prevState => ({
                wizard: {
                    ...prevState.wizard,
                    steps: steps
                },
                message: {
                    message: this.props.translate('jobnewpage.success.designupload'),
                    type: "success"
                },
                form : {
                    ...prevState.form,
                    name : this.props.helpersDesign.details.name.substr(0,50),
                    colors : this.props.helpersDesign.details.colors,
                    stitches : this.props.helpersDesign.details.stitches,
                    trims : this.props.helpersDesign.details.trims,
                    color_changes : this.props.helpersDesign.details.color_changes
                }
            }), () => {
                this.props.onCalculatorJobDuplicateCheck({name: this.props.helpersDesign.details.name.substr(0,50)});
                ReactTooltip.rebuild();
            });
        }
    }

	defaultValueHandler = (event) => {
    	if(this.props.calculatorJobsDefaults.defaults) {
    		this.setState(prevState => ({
	    		form: {
		            ...prevState.form,
		            orders : this.props.calculatorJobsDefaults.defaults.orders,
		            pieces: this.props.calculatorJobsDefaults.defaults.pieces,
		            stitches: this.props.calculatorJobsDefaults.defaults.stitches,
		            colors: this.props.calculatorJobsDefaults.defaults.colors > 0 ? this.props.calculatorJobsDefaults.defaults.colors : 1,
		            color_changes: this.props.calculatorJobsDefaults.defaults.color_changes,
		            trims: this.props.calculatorJobsDefaults.defaults.trims,
		            cone_changes: this.props.calculatorJobsDefaults.defaults.cone_changes,
		            garment_handling: this.props.calculatorJobsDefaults.defaults.garment_handling,
		            hooping: this.props.calculatorJobsDefaults.defaults.hooping,
		            other_work: this.props.calculatorJobsDefaults.defaults.other_work/60
	    		}
	    	}))
			
		}
    }

    newJobHandler = ( event ) => {
        event.preventDefault();
        if(this.state.wizard.steps[1].active) {
            if(this.props.state.job.name_checked && this.props.state.job.name_available) {
                this.submitHandler();
            }
            else {
                this.setState(prevState => ({
                    willSubmit : true
                }), () => {
                    this.duplicateCheckHandler(); 
                });
            }
        }
        else {
            this.submitHandler();
        }
    }

    designuploadChanged = (event, inputIdentifier) => {
        let formData = new FormData();
        formData.append('file',event.target.files[0])
        this.props.onHelpersDesignUpload(formData);
    }

    inputChangedHandler = (event, inputIdentifier) => {
        let value = event.target.value;
    	this.setState(prevState => ({
            form: {
                ...prevState.form,
                [inputIdentifier]: value
            }
        }));
    }

    inputBlurredHandler = (event, inputIdentifier) => {
        if(inputIdentifier === 'name') {
            this.duplicateCheckHandler();
        }
        FormHelpers.validateFields.apply(this,[[inputIdentifier]]);
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].hideTooltip();
        }
    }
    inputFocusHandler = (event, inputIdentifier) => {
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].showTooltip();
        }
    }

    duplicateCheckHandler = () => {
        if(this.state.wizard.steps[1].active) {
            if(this.refs.name.props.value.length) {
                this.setState(prevState => ({
                    form_blocked: true,
                    form_state : {
                        ...prevState.form_state,
                        name : {
                            ...prevState.form_state.name,
                            state : 'loading'
                        }
                    }
                }), () => {
                    this.props.onCalculatorJobDuplicateCheck({name: this.refs.name.props.value});
                });
            }
            else {
                this.setState(prevState => ({
                    form_blocked: false,
                    form_state : {
                        ...prevState.form_state,
                        name : {
                            ...prevState.form_state.name,
                            state : false
                        }
                    }
                }), () => {
                    this.submitHandler();
                });
            }
        }
        else if(this.state.willSubmit) {
            this.submitHandler();            
        }
    }
    submitHandler = () => {
        this.setState(prevState => ({
            message: this.defaultMessageState
        }));
        const formData = {
            name : this.state.form.name,
            orders: Number.isInteger(Number.parseInt(this.state.form.orders)) ? Number.parseInt(this.state.form.orders) : 0,
            pieces: Number.isInteger(Number.parseInt(this.state.form.pieces)) ? Number.parseInt(this.state.form.pieces) : 0,
            stitches: Number.isInteger(Number.parseInt(this.state.form.stitches)) ? Number.parseInt(this.state.form.stitches) : 0,
            colors: Number.isInteger(Number.parseInt(this.state.form.colors)) ? Number.parseInt(this.state.form.colors) : 0,
            color_changes: Number.isInteger(Number.parseInt(this.state.form.color_changes)) ? Number.parseInt(this.state.form.color_changes) : 0,
            trims: Number.isInteger(Number.parseInt(this.state.form.trims)) ? Number.parseInt(this.state.form.trims) : 0,
            cone_changes: Number.isInteger(Number.parseInt(this.state.form.cone_changes)) ? Number.parseInt(this.state.form.cone_changes) : 0,
            garment_handling: Number.isInteger(Number.parseInt(this.state.form.garment_handling)) ? Number.parseInt(this.state.form.garment_handling) : 0,
            hooping: Number.isInteger(Number.parseInt(this.state.form.hooping)) ? Number.parseInt(this.state.form.hooping) : 0,
            other_work: !Number.isNaN(Number.parseFloat(this.state.form.other_work)) ? Number.parseFloat(this.state.form.other_work)*60 : 0
        };
        //Step 1
        if(this.state.wizard.steps[0].active) {
            let steps = [...this.state.wizard.steps];
            steps[2].active = false;
            steps[1].active = true;
            steps[0].active = false;
            this.setState(prevState => ({
                wizard: {
                    ...prevState.wizard,
                    steps: steps
                }
            }), () => ReactTooltip.rebuild());
        }
        else  if(this.state.wizard.steps[1].active) {
            this.setState(prevState => ({
                    willSubmit : false
                }), () => {
                    if(FormHelpers.validateFields.apply(this,[['name','stitches','colors','color_changes','trims','cone_changes']])) {
                        let steps = [...this.state.wizard.steps];
                        steps[2].active = true;
                        steps[1].active = false;
                        steps[0].active = false;
                        this.setState(prevState => ({
                            wizard: {
                                ...prevState.wizard,
                                steps: steps
                            }
                        }), () => ReactTooltip.rebuild());
                    }
                    else {
                        this.setState(prevState => ({
                            message: {
                                show: true,
                                message: this.props.translate('jobnewpage.error.default'),
                                type: "error"
                            }
                        }))                
                    }
                }
            );
        }
        else if(this.state.wizard.steps[2].active) {
            this.setState(prevState => ({
                    willSubmit : false
                }), () => {
                    if(FormHelpers.validateFields.apply(this,[['orders','pieces','hooping','other_work','garment_handling']])) {
                        this.props.onCreateJob(formData);
                    }
                    else {
                        this.setState(prevState => ({
                            message: {
                                show: true,
                                message: this.props.translate('jobnewpage.error.default'),
                                type: "error"
                            }
                        }))                
                    }
                }
            );
        }
    }

	render() {
        var showMessage;
        if(this.state.message.message) {
            showMessage = this.state.message
        }
	  	return (
			<Aux>
                {this.props.state.job.created ? (<Redirect to={'/jobs/'+this.props.state.job.details.Id}  />) : (
					<PageTemplate header={<Header />}>
				      <Form onSubmit={this.newJobHandler}>
		                    {this.state.wizard.steps[0].active ? (
				            <GreyBox title={this.props.translate('jobnewpage.title')} msg={showMessage} steps={this.state.wizard.steps}>
			                    <Flex>
                                    <FlexColumn col="100*47">
                                        <UploadButton multiline="true" label={this.props.translate('jobnewpage.step_1.upload')} identifier="designupload" changed={this.designuploadChanged} nomargin="true" accept=".dst,.ofm,.exp"/>
                                    </FlexColumn>
                                    <FlexColumn col="100*47">
                                        <Button multiline="true" nomarginmobile="true" value={this.props.translate('jobnewpage.step_1.manual')} type="submit" nomargin="true"/>
				                    </FlexColumn>
                                </Flex>
                            </GreyBox>
		                    ) : null }
		                    {this.state.wizard.steps[1].active ? (
				            <GreyBox title={this.props.translate('jobnewpage.title')} msg={showMessage} steps={this.state.wizard.steps}>
			                    <InputRow label={this.props.translate('global.form.label.job.name')}
                                            ref="nameInputRow"
			                    			state={this.state.form_state.name.state ? this.state.form_state.name.state : null} 
			                    			tip={this.state.form_state.name.message ? this.state.form_state.name.message : null}>
			                        <Input 
			                            identifier="name"
                                        ref="name"
			                            type="text"
			                            value={this.state.form.name}
			                            changed={this.inputChangedHandler}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler}
                                        maxlength={50}
                                        isRequired={true} />
			                    </InputRow>
			                    <InputRow label={this.props.translate('global.form.label.job.stitches')} 
                                            ref="stitchesInputRow"
			                    			state={this.state.form_state.stitches.state ? this.state.form_state.stitches.state : null} 
			                    			tip={this.state.form_state.stitches.message ? this.state.form_state.stitches.message : null}
                                            hint={this.props.translate('global.help.job.stitches')}>
			                        <Input 
			                            identifier="stitches"
                                        ref="stitches"
			                            type="number"
                                        minValue={1}
                                        maxValue={999999}
			                            value={this.state.form.stitches}
			                            changed={this.inputChangedHandler}
                                        blurred={this.inputBlurredHandler}
                                        focused={this.inputFocusHandler}
                                        isRequired={true} />
			                    </InputRow>
			                    <Flex break="xs">
				                    <InputRow 	label={this.props.translate('global.form.label.job.colors')}
				                    			cols="2"
                                            	ref="colorsInputRow"
				                    			state={this.state.form_state.colors.state ? this.state.form_state.colors.state : null} 
				                    			tip={this.state.form_state.colors.message ? this.state.form_state.colors.message : null}
                                                hint={this.props.translate('global.help.job.colors')}>
				                        <Input 
				                            identifier="colors"
                                            ref="colors"
				                            type="number"
                                            minValue={1}
                                            maxValue={999}
				                            value={this.state.form.colors}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                    <InputRow 	label={this.props.translate('global.form.label.job.color_changes')}
				                    			cols="2"
                                            	ref="color_changesInputRow"
				                    			state={this.state.form_state.color_changes.state ? this.state.form_state.color_changes.state : null} 
				                    			tip={this.state.form_state.color_changes.message ? this.state.form_state.color_changes.message : null}
                                                hint={this.props.translate('global.help.job.color_changes')}>
				                        <Input 
				                            identifier="color_changes"
                                            ref="color_changes"
				                            type="number"
                                            minValue={0}
                                            maxValue={999}
				                            value={this.state.form.color_changes}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                    <InputRow 	label={this.props.translate('global.form.label.job.trims')}
				                    			cols="2"
                                            	ref="trimsInputRow"
				                    			state={this.state.form_state.trims.state ? this.state.form_state.trims.state : null} 
				                    			tip={this.state.form_state.trims.message ? this.state.form_state.trims.message : null}
                                                hint={this.props.translate('global.help.job.trims')}>
				                        <Input 
				                            identifier="trims"
                                            ref="trims"
				                            type="number"
                                            minValue={0}
                                            maxValue={999}
				                            value={this.state.form.trims}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                    <InputRow 	label={this.props.translate('global.form.label.job.cone_changes')}
				                    			cols="2"
                                            	ref="cone_changesInputRow"
				                    			state={this.state.form_state.cone_changes.state ? this.state.form_state.cone_changes.state : null} 
				                    			tip={this.state.form_state.cone_changes.message ? this.state.form_state.cone_changes.message : null}
                                                hint={this.props.translate('global.help.job.cone_changes')}>
				                        <Input 
				                            identifier="cone_changes"
                                            ref="cone_changes"
				                            type="number"
                                            minValue={0}
                                            maxValue={99}
				                            value={this.state.form.cone_changes}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                </Flex>
			                    <Button value={this.props.translate('jobnewpage.step_2.submit')} type="submit" />
				            </GreyBox>
		                    ) : null }
							{this.state.wizard.steps[2].active ? (
				            <GreyBox title={this.props.translate('jobnewpage.title')} msg={showMessage} steps={this.state.wizard.steps}>
			                    <Flex break="xs">
				                    <InputRow 	label={this.props.translate('global.form.label.job.orders')}
				                    			cols="2"
                                            	ref="ordersInputRow"
				                    			state={this.state.form_state.orders.state ? this.state.form_state.orders.state : null} 
				                    			tip={this.state.form_state.orders.message ? this.state.form_state.orders.message : null}
                                                hint={this.props.translate('global.help.job.orders')}>
				                        <Input 
				                            identifier="orders"
                                            ref="orders"
				                            type="number"
                                            minValue={1}
                                            maxValue={999999}
				                            value={this.state.form.orders}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                    <InputRow 	label={this.props.translate('global.form.label.job.pieces')}
				                    			cols="2"
                                            	ref="piecesInputRow"
				                    			state={this.state.form_state.pieces.state ? this.state.form_state.pieces.state : null} 
				                    			tip={this.state.form_state.pieces.message ? this.state.form_state.pieces.message : null}
                                                hint={this.props.translate('global.help.job.pieces')}>
				                        <Input 
				                            identifier="pieces"
                                            ref="pieces"
				                            type="number"
                                            minValue={1}
                                            maxValue={99999}
				                            value={this.state.form.pieces}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                    <InputRow 	label={this.props.translate('global.form.label.job.hooping')}
				                    			cols="2"
				                    			unit={this.props.translate('global.units.seconds')}
                                            	ref="hoopingInputRow"
				                    			state={this.state.form_state.hooping.state ? this.state.form_state.hooping.state : null} 
				                    			tip={this.state.form_state.hooping.message ? this.state.form_state.hooping.message : null}
                                                hint={this.props.translate('global.help.job.hooping')}>
				                        <Input 
				                            identifier="hooping"
                                            ref="hooping"
				                            type="number"
                                            minValue={0}
                                            maxValue={1200}
				                            value={this.state.form.hooping}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
				                    <InputRow 	label={this.props.translate('global.form.label.job.garment_handling')}
                                                cols="2"
				                    			unit={this.props.translate('global.units.seconds')}   
                                            	ref="garment_handlingInputRow"
				                    			state={this.state.form_state.garment_handling.state ? this.state.form_state.garment_handling.state : null} 
				                    			tip={this.state.form_state.garment_handling.message ? this.state.form_state.garment_handling.message : null}
                                                hint={this.props.translate('global.help.job.garment_handling')}>
				                        <Input 
				                            identifier="garment_handling"
                                            ref="garment_handling"
				                            type="number"
                                            minValue={0}
                                            maxValue={9999}
				                            value={this.state.form.garment_handling}
				                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
				                    </InputRow>
                                    <InputRow   label={this.props.translate('global.form.label.job.other_work')}
                                                unit={this.props.translate('global.units.minutes')}
                                                ref="other_workInputRow"
                                                state={this.state.form_state.other_work.state ? this.state.form_state.other_work.state : null} 
                                                tip={this.state.form_state.other_work.message ? this.state.form_state.other_work.message : null}
                                                hint={this.props.translate('global.help.job.other_work')}>
                                        <Input 
                                            identifier="other_work"
                                            ref="other_work"
                                            type="number"
                                            minValue={0}
                                            maxValue={9999}
                                            value={this.state.form.other_work}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any"
                                            validationPattern="^\d*(\.\d{0,1})?$" />
                                    </InputRow>
				                </Flex>
			                    <Button value={this.props.translate('jobnewpage.step_3.submit')} type="submit" />
				            </GreyBox>
		                    ) : null }
							<Box align="center">
		                    <Text size="small" align="center">{this.props.translate('jobnewpage.secondary.text')}</Text>
		                        <Button outerMargin="true" href="/jobs" theme="light" value={this.props.translate('jobnewpage.secondary.label')} width="320px" />
		                    </Box>
				        </Form>
				    </PageTemplate>
				)}
			</Aux>
		)
	}
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        calculatorJobsDefaults: state.calculatorJobsDefaults,
        state: state.calculatorJob,
        helpersDesign: state.helpersDesign,
        translate: getTranslate(state.locale)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onHelpersDesignUpload: (formData) => dispatch(actionCreators.helpersDesignupload(formData)),
        onCreateJob: (formData) => dispatch(actionCreators.calculatorJobCreate(formData)),
        onFetchJobsDefaults: () => dispatch(actionCreators.calculatorJobsDefaultsFetch()),
        onResetJob: () => dispatch(actionCreators.calculatorJobCreateReset()),
        onCalculatorJobDuplicateCheck: (formData) => dispatch(actionCreators.calculatorJobDuplicateCheck(formData)),
        onCalculatorJobDuplicateCheckReset: () => dispatch(actionCreators.calculatorJobDuplicateCheckReset())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(JobsNewPage, axios));



// WEBPACK FOOTER //
// ./src/components/pages/JobsNewPage/index.js